import { useEffect } from "react";
import ContentView from "../contentview";
import _ from "lodash";
import { commonUrl } from "../api/config";
import Head from 'next/head';
import CustomError from "../../components/CustomError";

const Posts = ({ dataStatus, data }) => {

  if (dataStatus === true && data) {
    return (
      <>
        <Head>
          <meta charSet="utf-8" />
          <title>{data && data.title != '' ? data.title : '錫安日報'}</title>
          <link rel="icon" type="image/x-icon" href="/favicon.ico"></link>
          <meta name="viewport" content="initial-scale=1.0, width=device-width" />
          <meta name='keywords' content={data && data.title != '' ? data.title : '錫安日報'} />
          <meta name='description' content={data && data.excerpt != '' ? data.excerpt : '錫安日報'} />
          <meta property='og:type' content='article' />
          <meta property='og:title' content={data && data.title != '' ? data.title : '錫安日報'} />
          <meta property='og:description' content={data && data.excerpt != '' ? data.excerpt : '錫安日報'} />
          {data.thumbnail && <meta property='og:image' content={data.thumbnail} />}
          <meta property='og:url' content={process.env.domain + data.id} />
          <meta property='og:site_name' content='鍚安日報' />
        </Head>
        <ContentView data={data} />
      </>
    );
  } else {
    return (<CustomError txt={data} />);
  }
}

export default Posts;

export async function getServerSideProps(context) { // { params }
  const { res } = context;
  res.setHeader('Cache-Control', `public, max-age=10, s-maxage=60, must-revalidate, stale-while-revalidate=3`);
  let postID = context.params.param[0];
  const response = await fetch(commonUrl.article + postID); // params.param[0]);

  if (response.status == 404) {
    //fail
    const dataStatus = false;
    const data = await response.text();
    return {
      props: { dataStatus, data } //revalidate: 60,
    }
  } else {
    //success
    const dataStatus = true;
    const data = await response.json();
    return {
      props: { dataStatus, data } //revalidate: 60,
    }
  }

}

